<template>
  <v-layout row justify-center>
    <v-dialog v-model="dialog" persistent max-width="290">
      <v-card>
        <v-card-title class="headline">Criterios aprobados</v-card-title>
        <v-card-text>Se aprobaron {{ criterios.approved }} de {{ criterios.total }} criterios</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click="submit">Continuar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
export default {
  props: {
    criterios: Object
  },

  data () {
    return {
      dialog: false
    }
  },

  methods: {
    openDialog () {
      this.dialog = true
    },
    submit () {
      this.dialog = false
      this.$router.push({ name: 'actualizaciones' })
    }
  }
}
</script>
